module.exports = __webpack_public_path__ + "static/media/CloudyField.f408ae71.dds";